// Public surface for `@/lib/impersonation` (spec 048).
//
// After the auth cutover (spec 009, FILE 14, Group F):
//   - Types, API client, TTL monitor, ImpersonationProvider, and
//     useImpersonation() live in @morfi/backend-sdk-v2.
//   - The Zustand store remains in the frontend (Zustand is a frontend dep).
//   - teardown.ts and header.ts are thin wrappers over the SDK with store baked in.
//
// Consumers should migrate to the SDK imports directly:
//   Types/hooks: import from '@morfi/backend-sdk-v2/client'
//   useImpersonation: import from '@morfi/backend-sdk-v2/client'
//   Store: import from '@/lib/impersonation/store'

export type {
  ActivateInput,
  GrantApiErrorCode,
  GrantApiErrorPayload,
  GrantConfig,
  GrantStatusResponse,
  ImpersonationActivatePayload,
  ImpersonationState,
  ImpersonationTarget,
  MintGrantResponse,
  ResolveTargetResponse,
  UseImpersonationResult,
} from '@morfi/backend-sdk-v2/client';
export {
  GrantApiClientError,
  ImpersonationProvider,
  useImpersonation,
} from '@morfi/backend-sdk-v2/client';
export { attachImpersonationHeader, IMPERSONATION_HEADER_NAME } from './header';
export { IMPERSONATION_PERSIST_KEY, useImpersonationStore } from './store';
